export const generalData = {
    name: "Lawrence Carreon",
    location: "Sydney",
    role: "full-stack engineer",
    course: "Software Engineering Immersive",
    education: "General Assembly",
    twitter: "https://twitter.com/LC_OoC",
    linkedin: "https://www.linkedin.com/in/lpcarreon",
    github: "https://github.com/OOC9490",
    email:"l.carreon123@gmail.com"
};

export const aboutData = {
    name: "Lawrence Carreon",
    description: 
    [ 
        "I am a Sydney based full-stack engineer with more than 2 years of experience in the education/ tech support industry and have previously worked in several customer service roles in hospitality. These roles have allowed me to cultivate skills in collaborative conduct, client management, along with communication, and appreciate the value of their applications.",
        "My pivot into full-stack development will hopefully allow me to part-take in more creative but challenging pursuits, and assist in pursuing my passion of all things digital!",
        "I am looking forward to developing my coding skill set further and to join an innovative team with a great learning culture."
    ],
    addressLine1: "New South Wales, Australia",
    phone: "0424 331 332",
    email: "l.carreon123@gmail.com"
};

export const resumeData = {
    education: [
        {
            institution: "General Assembly",
            courseName: "Software Engineering Immersive",
            completionDate: "May 2020",
        },
        {
            institution: "Australian College of Commerce and Management",
            courseName: "Certificate IV in Information Technology",
            completionDate: "November 2019",
        }
    ],
    experience: [
        {
            company: "Shore School",
            role: "Service Desk Officer",
            duration: "October 2017 - November 2019",
            roleSummary: "A role which involved handling incoming various queries and help requests from end users via either the organisation's customer relations management system or over the phone. After taking detailed notes of the user's experience, I would then determine steps I can either take myself or with my team to resolve the issue and log details of what actions were used to reach a resolution, as well as keeping the end user informed of the status of their request. I was also involved in the improvement of and/or implementation of automation software and scripts, as well as administering user access within the Shore intranet and managing the Standard Operating Environment (SOE) for user devices."
        },
        {
            company: "Cafe Harvest",
            role: "Customer Service/ Cafe Kitchen Hand",
            duration: "April 2015 - September 2017",
            roleSummary: "During my time at cafe harvest, I was seen as a versatile member of the team, able to work in both front-of-house (example duties: attending to customers, maintenance of the dining areas) and back-of-house (example duties: food preparation, handling and storage). During my time at Cafe Harvest, I was able to cultivate excellent communication, problem solving and interpersonal skills."
        }
    ],
    skills: [
        { 
            skillName: "Javascript",
            classStyling: "bar-expand javascript"
        },
        { 
            skillName: "jQuery",
            classStyling: "bar-expand jquery"
        },
        { 
            skillName: "ReactJS",
            classStyling: "bar-expand react"
        },
        { 
            skillName: "CSS",
            classStyling: "bar-expand css"
        },
        { 
            skillName: "HTML5",
            classStyling: "bar-expand html5"
        },
        { 
            skillName: "Ruby on Rails",
            classStyling: "bar-expand rails"
        },
        { 
            skillName: "Git",
            classStyling: "bar-expand git"
        },
        { 
            skillName: "NoSQL",
            classStyling: "bar-expand nosql"
        },
        { 
            skillName: "Postgres",
            classStyling: "bar-expand postgres"
        },
        { 
            skillName: "Express",
            classStyling: "bar-expand express"
        },
        { 
            skillName: "MongoDB",
            classStyling: "bar-expand mongo"
        }
    ]
};

export const portfolioData = {
    webArcade: {
        title: "Lawrence's Web Arcade",
        image: "images/portfolio/webarcade-project.png",
        preview: "images/portfolio/WebArcade_Preview.gif",
        description: "My first project within web development, it aims to recreate the some classic games in Javascript and jQuery!",
        alt: "Lawrence's web arcade preview",
        category: "Front-End",
        liveLink: "https://ooc9490.github.io/sei36-project0/index.html",
        tags: [ "Javascript", "jQuery", "HTML5", "CSS" ],
        repoLink: "https://github.com/OOC9490/sei36-project0"
    },
    smashWiki: {
        title: "Smash Bros Wiki",
        image: "images/portfolio/smashwiki-project.png",
        preview: "images/portfolio/SmashWiki_Preview.gif",
        description: "My first shot at designing a website with a CRUD system utilising Ruby on Rails!",
        alt: "Lawrence's smash-wiki preview",
        category: "Full-stack",
        liveLink: "https://smash-wiki-lpc.herokuapp.com/",
        tags: [ "Ruby", "Ruby on Rails", "Postgres", "ActiveRecord", "CSS" ],
        repoLink: "https://github.com/OOC9490/sei36-project1"
    },
    delivree: {
        title: "Delivree",
        image: "images/portfolio/delivree-project.png",
        preview: "images/portfolio/Delivree_Preview.gif",
        description: "A group project that was designed to help online food retailers to manage their delivery orders. Developed with the 'MERN' tech stack.",
        alt: "Lawrence's delivree preview",
        category: "Full-stack",
        liveLink: "https://delivree-estore-3a4z5l.netlify.app/#/",
        tags: [ "MongoDB", "Express", "ReactJS", "NodeJS" ],
        repoLinkFront: "https://github.com/OOC9490/Frontend-Project2",
        repoLinkBack: "https://github.com/OOC9490/backend-estore"
    },
    tetris: {
        title: "Tetris on React",
        image: "images/portfolio/tetris-project.png",
        preview: "images/portfolio/Tetris_React_Preview.gif",
        description: "A project designed to recreate tetris utilising ReactJS's hooks to manage the game state and do computations.",
        alt: "Lawrence's tetris preview",
        category: "Front-End",
        liveLink: "https://ooc9490-tetris-react.netlify.app/",
        tags: [ "ReactJS", "React Hooks", "Reactstrap" , "Bootstrap" ],
        repoLink: "https://github.com/OOC9490/project3"
    },
};

